import { Injectable } from '@angular/core';
import { Company } from 'src/app/model/contacts/company';
import { BaseTableService } from './base-table.service';

@Injectable({
  providedIn: 'root',
})
export class CompanyTableService extends BaseTableService<Company> {
  constructor() {
    super();
  }
}
